<template>
  <v-row>
    <v-col cols="12" sm="3">
      <v-menu
        v-model="date_min_menu"
        :close-on-content-click="false"
        full-width
        max-width="290"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="date_min_formated"
            clearable
            label="Data inicial"
            @click:clear="clear_date_min"
            readonly
            prepend-icon="event"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="filters.date_min"
          @change="changeFilter($event, date = true)"
          @input="date_min_menu_input"
          locale="pt-br"
        ></v-date-picker>
      </v-menu>
    </v-col>

    <v-col cols="12" sm="3">
      <v-menu
        v-model="date_max_menu"
        :close-on-content-click="false"
        full-width
        max-width="290"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="date_max_formated"
            clearable
            label="Data Final"
            @click:clear="clear_date_min"
            readonly
            prepend-icon="event"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="filters.date_max"
          @change="changeFilter($event, date = true)"
          @input="date_max_menu_input"
          locale="pt-br"
        ></v-date-picker>
      </v-menu>
    </v-col>    
    <!-- lojas -->
    <v-col cols="6" sm="3">
      <div v-if="$store.state.user.user_role_id == 2">
        <v-select
          selectable
          v-model="filters.store_id"
          item-text="name"
          item-value="id"
          :items="($store.state.user.attending_stores.length) ? 
            $store.state.user.attending_stores.concat(allStores).reverse() : []"
          label="Selecione a Loja"
          no-data-text="Nenhuma loja cadastrada"
          @input="changeFilter"
        ></v-select>
      </div>
      <div v-else>
        <v-select
          selectable
          v-model="filters.store_id"
          item-text="name"
          item-value="id"
          :items="($store.state.stores.length) ? 
            $store.state.stores.concat(allStores).reverse() : []"
          label="Selecione a Loja"
          no-data-text="Nenhuma loja cadastrada"
          @input="changeFilter"
        ></v-select>
      </div>      
    </v-col>

    <!-- Atendentes -->
    <v-col cols="6" sm="3">
      <div v-if="$store.state.user.user_role_id == 2">
        <v-select
          v-model="filters.user_id"
          item-text="name"
          item-value="id"
          :items="$store.state.user "
          label="Selecione o Atendente"
          no-data-text="Nenhum atendente cadastrado"
          @input="changeFilter"
        ></v-select>
      </div>
      <div v-else>
        <v-select
        v-model="filters.user_id"
        item-text="name"
        item-value="id"
        :items="($store.state.attending_stores.length) ?
          $store.state.attending_stores.concat(allUserStore).reverse() : []"
        label="Selecione o Atendente"
       no-data-text="Nenhum atendente cadastrado"
        @input="changeFilter"
      ></v-select>
      </div>
      
    </v-col>
    
  </v-row>
</template>

<script>

import moment from "moment";

export default {
  name: "Filters",
  methods: {
    submit() {
      this.$store.dispatch('fetchUserStoreReport', {
        'filters': this.filters,
        'callback': () => this.$emit('updateReport')
      });
    },
    changeFilter(e, date = false) {
      if(date) {
        this.date_min_menu = false;
        this.date_max_menu = false;
      }

      if(this.filters.user_id && this.filters.store_id) {
        this.submit();
      }
      
      console.log(this.filters);
    },
    clear_date_min() {
      this.filters.date_min = null;
      // this.emitUpdateFilters();
    },
    date_min_menu_input(e) {
      // this.filters.date_min = moment(e, "YYYY-MM-DD");
      // this.emitUpdateFilters();
    },
    date_max_menu_input (e) {
      // this.emitUpdateFilters();
    },
    dateFormattedMomentjs(date) {
      return date ? moment(date).format("DD/MM/YYYY") : "";
    },
  },
  computed: {
    date_min_formated() {
      return this.dateFormattedMomentjs(this.filters.date_min);
    },
    date_max_formated () {
      return this.dateFormattedMomentjs(this.filters.date_max);
    },
  },
  created() {
    // se houver algum relatorio previamente setado, remove
    this.$store.state.user_store_report = null;

    // carrega os filtros
    this.$store.dispatch('fetchStores');
    this.$store.dispatch('fetchAttendantStores');   
  },
  data() {
    return {
      valid: false,
      date_min_menu: false,
      date_max_menu: false,
      filters: {
        user_id: null,
        store_id: null,
        date_min: moment().startOf("month").format("YYYY-MM-DD"),
        date_max: moment().endOf("month").format("YYYY-MM-DD")
      },
      allStores: {
        name: "Todas as Lojas",
        id: -1
      },
      allUserStore: {
        name: "Todos os Atendentes",
        id: -1
      }
    };
  },
};
</script>